import service, {
  PandoResponse,
} from '@customer/services/pandoService/service';

const setBackupPaymentMethod = async (
  {
    accountGuid,
    paymentMethodId,
  }: { accountGuid: string; paymentMethodId: number },
  { accessToken }: { accessToken: string }
) => {
  const response = service.post<PandoResponse<undefined>>(
    `/api/setBackupPaymentMethod`,
    { PaymentMethodId: paymentMethodId },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accountguid: accountGuid,
      },
    }
  );
  return response;
};

export default setBackupPaymentMethod;
